<template>
  <div class="coproducer-links">
    <div class="row">
      <div class="col-lg-9">
        <links-inputs
          v-if="product && product.type_product !== 'signature'"
          :product="product"
        />

        <div v-if="product.type_product == 'signature'">
          <action-dispatcher
            action="plan/get"
            :parameters="{ product_id: product.id }"
          >
            <h6 class="mt-6">Links do plano</h6>
            <form-group
              v-model="filters.plan"
              id="plan-filter"
              placeholder="Selecione..."
              select
              :options="plans"
            />
          </action-dispatcher>

          <links-inputs
            v-if="filters.plan"
            :product="product"
            :plan_offer="plan"
            :group="group"
            label="Checkout customizado"
          />
        </div>

        <div v-else-if="product.type_product == 'online_course'">
          <action-dispatcher
            action="offer/get"
            :parameters="{ product_id: product.id }"
          >
            <h6 class="mt-6">Links da oferta</h6>
            <form-group
              v-model="filters.offer"
              id="offer-filter"
              placeholder="Selecione..."
              select
              :options="offers"
            />
          </action-dispatcher>

          <links-inputs
            v-if="filters.offer"
            :product="product"
            :plan_offer="offer"
            :group="group"
            label="Checkout customizado"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LinksInputs from "@/components/product/LinksInputs";
import { mapState } from "vuex";
export default {
  components: {
    LinksInputs
  },
  props: {
    product: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      filters: {
        plan: "",
        offer: ""
      }
    };
  },
  computed: {
    ...mapState("plan", ["plans"]),
    ...mapState("offer", ["offers"]),
    ...mapState("membersGroups", ["groupsFilter"]),
    plan() {
      return this.plans.find(plan => plan.id === this.filters.plan);
    },
    offer() {
      return this.offers.find(offer => offer.id === this.filters.offer);
    }
  },
  watch: {
    "filters.offer"() {
      this.dispatch({
        product_id: this.product.id,
        offers_id: this.offer.code
      });
    },
    "filters.plan"() {
      this.dispatch({
        product_id: this.product.id,
        plans_id: this.plan.code
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.coproducer-links {
  .secondary-title-subtitle {
    cursor: pointer;
  }
  h4,
  h6 {
    color: rgba(59, 59, 74, 0.9);
    font-weight: 400;
  }
}
</style>
